import { Link } from "react-router-dom";
import { connect } from "react-redux";

var StudentDisplay = require("components/users/students/StudentDisplay");
var ReactTooltip = require("react-tooltip");
var RosterSelectors = require("lib/selectors/RosterSelectors");

require("reading/participating_students_display.scss");

@connect(
	(state, props) => {
		// This isn't particularly elegant
		var studentNameLookup = {}
		_.each(RosterSelectors.students({ state }), (student) => {
			studentNameLookup[student.id] = student.display_name;
		})

		var orgIdentifier = RosterSelectors.orgIdentifierForStudents({
			state, studentIDs: props.studentIDs
		});

		if (orgIdentifier) {
			var groupText = RosterSelectors.nameForOrgIdentifier({
				state, orgIdentifier, fallback: "Select one"
			});
		}

		return {
			studentNameLookup, groupText
		};
	},

	(dispatch, props) => ({})
)

class ParticipatingStudentsDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {};
	}

	render() {		
		if (this.props.groupText) {
			var studentsDisplayContainer = (
				<div className="allStudentsDisplay">
					<img src={ require("owls/group-owls.png") } alt=""/> { this.props.groupText }
				</div>
			);
		} else {
			var studentsDisplay = _.first(this.props.studentIDs, this.props.maxDisplayStudentCount).map((studentID) => {
				return (
					<div key={ studentID } className="studentAvatarWrap b-tooltip"
						data-tip={ this.props.studentNameLookup[studentID] }>
						<StudentDisplay studentID={ studentID }
							showAvatar hideName={ true }
							avatarMaxWidth={ 30 } />
						<ReactTooltip effect="solid" />
					</div>
				)
			});
			if (this.props.maxDisplayStudentCount && this.props.studentIDs.length > this.props.maxDisplayStudentCount) {
				var moreStudents = (
					<div className="moreStudentsContainer">
						<span> +{ this.props.studentIDs.length - this.props.maxDisplayStudentCount }</span>
						<span className="moreText"> more</span>
					</div>
				)
			}
			var studentsDisplayContainer = (
				<div className="studentsDisplayContainer">
					{ studentsDisplay }
					{ moreStudents }
				</div>
			);
		}
		

		return (
			<div className="participatingStudentsDisplay">
				{ studentsDisplayContainer }
			</div>
		)
	}
}

ParticipatingStudentsDisplay.WrappedComponent.propTypes = StrictPropTypes({
	maxDisplayStudentCount: PropTypes.number,
	studentIDs: PropTypes.array,
	groupText: PropTypes.string,

	// Show a spinner and block onEnd notices if this is true
	loading: PropTypes.bool,

	studentNameLookup: PropTypes.object
});

module.exports = ParticipatingStudentsDisplay;


// WEBPACK FOOTER //
// ./modules/components/reading/ParticipatingStudentsDisplay.js